module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header"
  }, [(_vm.visible) ? _c('div', {
    staticClass: "topbar"
  }, [_c('a', {
    staticClass: "btn-setting iconfont",
    attrs: {
      "href": "javascript:;"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("发现")])]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "nav-list",
    class: {
      noMargin: _vm.isWechat
    }
  }, [_c('li', {
    staticClass: "list-item"
  }, [_c('a', {
    attrs: {
      "href": "tel:400-770-5127"
    }
  }, [_c('div', {
    staticClass: "iconfont",
    class: {
      marginBottom: _vm.isWechat
    }
  }, [_c('span', [_vm._v("")])]), _vm._v(" "), _c('span', {
    staticClass: "list-txt"
  }, [_vm._v("客服电话")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "phone"
  }, [_vm._v("400-770-5127")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "phone"
  }, [_vm._v(_vm._s(_vm.custServiceTime[0].customerServiceTime))])])]), _vm._v(" "), _c('a', {
    staticClass: "list-item",
    on: {
      "click": _vm.goService
    }
  }, [_c('div', {
    staticClass: "iconfont",
    class: {
      marginBottom: _vm.isWechat
    }
  }, [_vm._v("")]), _vm._v(" "), _c('span', {
    staticClass: "list-txt"
  }, [_vm._v("查询服务")])])])]), _vm._v(" "), _c('ul', {
    staticClass: "section"
  }, [_c('router-link', {
    staticClass: "section-item",
    attrs: {
      "tag": "li",
      "to": "/discover/instructions"
    }
  }, [_c('div', [_vm._v("办理房屋抵押须知")]), _vm._v(" "), _c('span', {
    staticClass: "triangle"
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "section-item",
    attrs: {
      "tag": "li",
      "to": "/discover/process"
    }
  }, [_c('div', [_vm._v("业务办理流程")]), _vm._v(" "), _c('span', {
    staticClass: "triangle"
  })])], 1), _vm._v(" "), _c('ul', {
    staticClass: "section1"
  }, [_c('router-link', {
    staticClass: "section-item",
    attrs: {
      "tag": "li",
      "to": "/consultant"
    }
  }, [_c('div', [_vm._v("业务咨询")]), _vm._v(" "), _c('span', {
    staticClass: "triangle"
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "section-item",
    attrs: {
      "tag": "li",
      "to": "/perspective"
    }
  }, [_c('div', [_vm._v("伟嘉视角")]), _vm._v(" "), _c('span', {
    staticClass: "triangle"
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "section-item",
    attrs: {
      "tag": "li",
      "to": "/culture"
    }
  }, [_c('div', [_vm._v("企业文化")]), _vm._v(" "), _c('span', {
    staticClass: "triangle"
  })])], 1), _vm._v(" "), _c('router-link', {
    staticClass: "wechat",
    attrs: {
      "tag": "div",
      "to": "/discover/follow"
    }
  }, [_c('div', [_vm._v("关注微信 "), _c('span', {
    staticClass: "wechat-num"
  }, [_vm._v("weijiarongzi")])]), _vm._v(" "), _c('span', {
    staticClass: "triangle"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1380f2d8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/discover/discover.vue
// module id = 333
// module chunks = 1